export default __webpack_public_path__ + "static/media/icon-node-completed.6bc4ed85.svg";